import { num } from '../../scene/component-types.js';
import { CollisionMatrix } from '../editors/CollisionMatrix.js';
import type { SettingsSection } from '../settings-types.js';

/** `settings.physics` (prism_core::physics::PhysicsSettings) and the layer collision matrix. */
const physics: SettingsSection = {
  key: 'physics',
  label: 'Physics',
  icon: 'magnet',
  order: 34,
  hint: 'Gravity, solver, sleeping, layer collision matrix',
  render: CollisionMatrix,
  renderAt: 'end',
  fields: [
    { key: 'gravity', label: 'Gravity', type: { kind: 'vec3', step: 0.1 }, read: () => [0, -9.81, 0], hint: 'm/s²' },
    { key: 'solverIterations', label: 'Solver iterations', type: num(1, { min: 1, max: 64, integer: true }), read: () => 4, hint: 'more = stiffer stacks and joints, slower (1..64)' },
    { key: 'stabilizationIterations', label: 'Stabilization iterations', type: num(1, { min: 0, max: 64, integer: true }), read: () => 1, hint: 'extra position-correction passes per solver iteration (0..64)' },
    { key: 'defaultCcd', label: 'Continuous collision', type: { kind: 'bool' }, read: () => false, hint: 'CCD for bodies that do not set rigidBody.ccd (fast objects do not tunnel)' },
    { key: 'sleepThreshold', label: 'Sleep threshold', type: num(0.01), read: () => 0.05, hint: 'm/s below which bodies may sleep (negative = never sleep)' },
    { key: 'sleepAngularThreshold', label: 'Sleep angular threshold', type: num(0.05), read: () => 0.5, hint: 'rad/s below which collider-less bodies may sleep' },
    { key: 'sleepTime', label: 'Sleep time', type: num(0.05), read: () => 0.5, hint: 'seconds below the thresholds before a body sleeps' },
    {
      key: 'defaultMaterial',
      label: 'Default material',
      type: { kind: 'path', suffix: '.physicsmat.json', allowObject: true, label: 'Physics Material' },
      hint: 'material of colliders (and terrain / tilemaps) without their own',
    },
    {
      key: 'queriesHitTriggers',
      label: 'Queries hit triggers',
      type: { kind: 'bool' },
      hint: 'raycasts / shape casts / overlaps hit trigger colliders (unset: casts skip them, overlaps include them)',
    },
    {
      key: 'topDown',
      label: '2D top-down',
      type: { kind: 'bool' },
      hint: '2D projects: characters move freely in XY without gravity (unset: top-down when gravity.y is 0)',
    },
  ],
};

export default physics;
